(() => {
  (function() {
    "use strict";
    const s = (e, t = document) => t.querySelector(e), h = (e, t = document) => Array.from(t.querySelectorAll(e)), S = "pawling_saved_puppies_v1";
    function g() {
      try {
        return JSON.parse(localStorage.getItem(S) || "[]");
      } catch (e) {
        return [];
      }
    }
    function P(e) {
      localStorage.setItem(S, JSON.stringify(e)), v(), w(), window.__pawlingSavedResultsActive && $("", "", false, { savedOnly: true });
    }
    function x(e) {
      return !e || e.dataset.pawlingActive === "false" ? false : !(/* @__PURE__ */ new Set(["placed", "sold", "adopted", "closed", "inactive", "expired"])).has(o(e.dataset.searchStatus || e.dataset.status));
    }
    function f() {
      var i;
      if (!((i = document.body) != null && i.classList.contains("template-index"))) return;
      const e = new Set(h("[data-pawling-market-card]").filter(x).map((n) => n.dataset.id).filter(Boolean)), t = g(), a = t.filter((n) => e.has(n));
      a.length !== t.length && localStorage.setItem(S, JSON.stringify(a));
    }
    function v() {
      const e = g();
      h("[data-pawling-saved-count]").forEach((t) => {
        t.textContent = e.length, t.hidden = e.length === 0;
      }), h("[data-pawling-favorite]").forEach((t) => {
        const a = e.includes(t.dataset.pawlingFavorite);
        t.classList.toggle("is-saved", a), t.setAttribute("aria-pressed", a ? "true" : "false");
        const i = t.querySelector("[data-favorite-label]");
        i && (i.textContent = a ? "Saved" : "Save");
      });
    }
    function y(e) {
      const t = g(), a = t.includes(e) ? t.filter((i) => i !== e) : [...t, e];
      P(a), b(t.includes(e) ? "Removed from saved pets." : "Pet ad saved on this device.");
    }
    function b(e) {
      const t = s("#PawlingToast");
      t && (t.textContent = e, t.classList.add("show"), clearTimeout(window.__pawlingToast), window.__pawlingToast = setTimeout(() => t.classList.remove("show"), 2600));
    }
    function u(e, t) {
      const a = Object.assign({ event: "pawling_" + e }, t || {});
      try {
        document.dispatchEvent(new CustomEvent("pawling:" + e, { detail: t || {} }));
      } catch (i) {
      }
      try {
        Array.isArray(window.dataLayer) && window.dataLayer.push(a);
      } catch (i) {
      }
    }
    function o(e) {
      return (e || "").trim().toLowerCase();
    }
    function m(e, t, a) {
      if (!e || e.dataset.populated === "true") return;
      const i = [...new Set(t.filter(Boolean))].sort((n, c) => n.localeCompare(c));
      e.innerHTML = `<option value="">${a}</option>` + i.map((n) => `<option value="${n.replace(/"/g, "&quot;")}">${n}</option>`).join(""), e.dataset.populated = "true";
    }
    function w() {
      var A, L, T, I, O;
      const e = s("#PawlingPuppyGrid");
      if (!e) return;
      const t = h("[data-pawling-puppy-card]", e), a = o((A = s("#PawlingKeyword")) == null ? void 0 : A.value), i = o((L = s("#PawlingBreed")) == null ? void 0 : L.value), n = o((T = s("#PawlingSex")) == null ? void 0 : T.value), c = o((I = s("#PawlingStatus")) == null ? void 0 : I.value), p = !!((O = s("#PawlingSavedOnly")) != null && O.checked), r = g();
      let l = 0;
      t.forEach((d) => {
        const U = o([d.dataset.name, d.dataset.breed, d.dataset.sex, d.dataset.location, d.dataset.color, d.dataset.description, d.dataset.seller, d.dataset.sellerKey].join(" ")), D = d.dataset.pawlingActive !== "false" && (!a || U.includes(a)) && (!i || o(d.dataset.breed) === i) && (!n || o(d.dataset.sex) === n) && (!c || o(d.dataset.status) === c) && (!p || r.includes(d.dataset.id));
        d.hidden = !D, D && l++;
      });
      const q = s("#PawlingPuppyCount");
      q && (q.textContent = `${l} featured ${l === 1 ? "listing" : "listings"}`);
      const B = s("#PawlingPuppyEmpty");
      B && (B.hidden = l !== 0);
    }
    function C(e) {
      h("[data-pawling-quick-breed]").forEach((t) => {
        const a = (t.dataset.pawlingQuickBreed || "") === e;
        t.classList.toggle("is-active", a), t.setAttribute("aria-pressed", a ? "true" : "false");
      });
    }
    function ie() {
      const e = s(".pawling-dog-type-browser");
      if (!e) return;
      const t = h("[data-pawling-quick-breed]", e).map((n) => E(n.dataset.pawlingQuickBreed || "")).filter(Boolean), a = h("#current-listings [data-pawling-live-listing]").filter((n) => n.dataset.pawlingActive !== "false" && n.dataset.petCategory === "dogs");
      a.forEach((n) => {
        const c = String(n.dataset.searchType || "").trim(), p = E(c);
        if (!p || c.length > 60 || t.some((r) => p === r || p.includes(r) || r.includes(p))) return;
        const r = document.createElement("button");
        r.type = "button", r.dataset.pawlingQuickBreed = c, r.dataset.liveBreedTab = "true", r.setAttribute("aria-pressed", "false"), r.textContent = c, r.title = `Browse current ${c} ads`, e.appendChild(r), t.push(p);
      });
    }
    function _() {
      const e = h("[data-pawling-puppy-card]").filter((a) => a.dataset.pawlingActive !== "false");
      if (!e.length) return;
      m(s("#PawlingBreed"), e.map((a) => a.dataset.breed), "All breeds"), ["PawlingKeyword", "PawlingBreed", "PawlingSex", "PawlingStatus", "PawlingSavedOnly"].forEach((a) => {
        const i = document.getElementById(a);
        !i || i.dataset.bound || (i.addEventListener(i.type === "search" || i.type === "text" ? "input" : "change", () => {
          C(null), w();
        }), i.dataset.bound = "true");
      });
      const t = s("#PawlingResetFilters");
      t && !t.dataset.bound && (t.addEventListener("click", () => {
        ["PawlingKeyword", "PawlingBreed", "PawlingSex", "PawlingStatus"].forEach((a) => {
          const i = document.getElementById(a);
          i && (i.value = "");
        }), s("#PawlingSavedOnly") && (s("#PawlingSavedOnly").checked = false), C(""), w();
      }), t.dataset.bound = "true"), h("[data-pawling-quick-breed]").forEach((a) => {
        a.dataset.bound || (a.addEventListener("click", (i) => {
          var l;
          i.preventDefault();
          const n = a.dataset.pawlingQuickBreed || "", c = s("#PawlingBreed"), p = s("#PawlingKeyword"), r = c ? Array.from(c.options).some((q) => q.value === n) : false;
          c && (c.value = r ? n : ""), p && (p.value = r ? "" : n), C(n), w();
          const hero = s("#PawlingHeroSearch");
          if (hero) {
            hero.elements.pawling_keyword.value=n;
            window.PawlingMarketTools?.setCategory(n ? "dogs" : "");
            const dogControl=s('#current-listings [data-pawling-pet-category="dogs"]');
            ae(n ? "dogs" : "",n ? (dogControl?.dataset.categoryLabel || "Dogs") : "All pets",false);
            hero.requestSubmit();
          }
          else if (n) $(n, "", true);
          else {
            window.__pawlingSavedResultsActive = false;
            const q = s("#pet-search-results");
            q && (q.hidden = true), (l = s("#puppies")) == null || l.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }), a.dataset.bound = "true");
      }), w();
    }
    function E(e) {
      return String(e || "").normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
    }
    function N(e, t) {
      const a = E(e);
      return E(t).split(/\s+/).filter(Boolean).every((n) => a.includes(n));
    }
    function R(e, t) {
      const a = E(t);
      return !a || N(e, a);
    }
    function F(e) {
      var i, n, c;
      const t = e.dataset, a = e.querySelector("img");
      return { element: e, id: t.id || "", title: t.searchTitle || t.name || ((n = (i = e.querySelector("h3")) == null ? void 0 : i.textContent) == null ? void 0 : n.trim()) || "Pawling pet ad", type: t.searchType || t.breed || t.category || "Pet listing", category: t.category || "Pet listing", petCategory: t.petCategory || "", location: t.searchLocation || t.location || "", state: t.searchState || "", city: t.searchCity || "", advertiser: t.searchAdvertiser || t.seller || "", description: t.searchDescription || t.description || "", status: t.searchStatus || t.status || "", price: t.searchPrice || "", source: t.searchSource || "Pawling listing", tier: t.planTier || "", promoted: t.promotionLabel !== undefined ? !!t.promotionLabel : t.pawlingBoostActive === "true" || t.pawlingRotationActive === "true", promotionLabel: t.promotionLabel !== undefined ? t.promotionLabel : t.pawlingBoostActive === "true" ? "Featured" : t.pawlingRotationActive === "true" ? "Elite Spotlight" : "", dialog: t.searchDialog || ((c = e.querySelector("[data-open-dialog]")) == null ? void 0 : c.dataset.openDialog) || "", image: (a == null ? void 0 : a.currentSrc) || (a == null ? void 0 : a.src) || "" };
    }
    function G(e) {
      const t = document.createElement("article");
      t.className = "pawling-unified-result-card", e.promoted && t.classList.add("is-promoted");
      const a = document.createElement("div");
      if (a.className = "pawling-unified-result-media", e.image) {
        const l = document.createElement("img");
        l.src = e.image, l.alt = e.title, l.loading = "lazy", a.appendChild(l);
      } else {
        const l = document.createElement("span");
        l.className = "pawling-live-listing-placeholder", l.textContent = (e.title || "P").slice(0, 1), a.appendChild(l);
      }
      const i = document.createElement("div");
      i.className = "pawling-unified-result-copy";
      const n = document.createElement("span");
      n.className = "pawling-unified-result-kicker", n.textContent = [e.source, e.promotionLabel, e.status].filter(Boolean).join(" \u2022 ");
      const c = document.createElement("h3");
      c.textContent = e.title;
      const p = document.createElement("p");
      p.textContent = [e.type, e.location, e.price].filter(Boolean).join(" \xB7 "), i.append(n, c, p);
      const r = document.createElement("div");
      if (r.className = "pawling-unified-result-actions", e.dialog) {
        const l = document.createElement("button");
        l.type = "button", l.className = "button button-primary", l.dataset.openDialog = e.dialog, l.textContent = "View & contact", r.appendChild(l);
      }
      if (e.id) {
        const l = document.createElement("button");
        l.type = "button", l.className = "button button-light", l.dataset.pawlingFavorite = e.id, l.setAttribute("aria-pressed", "false");
        const q = document.createElement("span");
        q.dataset.favoriteLabel = "", q.textContent = "Save", l.appendChild(q), r.appendChild(l);
      }
      window.PawlingMarketTools?.addResultTools(r,e);
      return i.appendChild(r), t.append(a, i), t;
    }
    function $(e, t, a, i) {
      const n = i || {}, c = s("#pet-search-results"), p = s("#PawlingUnifiedResultsGrid"), r = s("#PawlingUnifiedResultsSummary"), l = s("#PawlingUnifiedResultsHeading"), q = s("#PawlingUnifiedResultsEmpty");
      if (!c || !p || !r || !q) return;
      const B = g(), A = /* @__PURE__ */ new Set(), L = h("[data-pawling-market-card]").filter(x).map(F).filter((d) => {
        if (n.savedOnly && (!d.id || !B.includes(d.id))) return false;
        if (!n.savedOnly && window.PawlingMarketTools && !window.PawlingMarketTools.matches(d)) return false;
        const U = [d.title, d.type, d.category, d.location, d.advertiser, d.description, d.status].join(" ");
        if (!N(U, e) || !(window.PawlingGeography ? window.PawlingGeography.matches(d.location, t, n.state || "", d.id, d.state, d.city, n.exactCity) : R(d.location, t))) return false;
        const D = d.id || d.dialog || [d.title, d.location, d.advertiser].join("|");
        return A.has(D) ? false : (A.add(D), true);
      });
      window.PawlingMarketTools?.sortRows(L);
      window.__pawlingSavedResultsActive = !!n.savedOnly, p.replaceChildren(...L.map(G)), c.hidden = false, l && (l.textContent = n.savedOnly ? "Your saved Pawling ads" : "Matching Pawling ads");
      const T = [e ? "\u201C" + e.trim() + "\u201D" : "", t ? "near " + t.trim() : "", n.state ? "in " + (window.PawlingGeography?.stateName(n.state) || n.state) : ""].filter(Boolean).join(" ");
      r.textContent = L.length ? L.length + " current " + (L.length === 1 ? "pet ad" : "pet ads") + (T ? " for " + T : "") + ". Save favorites here and come back anytime." : n.savedOnly ? "No saved ads are available on this device yet." : "No current pet ads match those search fields.";
      const I = q.querySelector("h3"), O = q.querySelector("p");
      I && (I.textContent = n.savedOnly ? "No saved pet ads yet." : "No current pet ads match this search."), O && (O.textContent = n.savedOnly ? "Browse current ads and tap Save so you can compare and return later." : "Try a broader pet type, breed or nearby city\u2014or browse every animal category."), q.hidden = L.length !== 0, v();
      try {
        document.dispatchEvent(new CustomEvent("pawling:search_pet", { detail: { keyword: e || "", location: t || "", results: L.length, savedOnly: !!n.savedOnly } })), Array.isArray(window.dataLayer) && window.dataLayer.push({ event: "pawling_search_pet", pawling_search_keyword: e || "", pawling_search_location: t || "", pawling_search_results: L.length });
      } catch (d) {
      }
      a && c.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    function J() {
      const e = s("#PawlingHeroSearch");
      e && !e.dataset.marketBound && (e.addEventListener("submit", (a) => {
        var c, p;
        a.preventDefault();
        const i = ((c = e.querySelector('[name="pawling_keyword"]')) == null ? void 0 : c.value) || "", n = ((p = e.querySelector('[name="pawling_location"]')) == null ? void 0 : p.value) || "";
        window.__pawlingSavedResultsActive = false;
        const state = window.PawlingGeography?.formState() || "";
        window.PawlingGeography?.syncUrl(i,n,state);
        window.PawlingMarketTools?.syncUrl();
        $(i,n,e.dataset.pawlingKeepBrowse!=="true",{state,exactCity:window.PawlingGeography?.formExactCity()});
        const active=s("#current-listings [data-pawling-pet-category].is-active");
        ae(active?.dataset.pawlingPetCategory || "",active?.dataset.categoryLabel || "All pets",false);
        window.PawlingGeography?.decorate();
      }), e.dataset.marketBound = "true");
      const t = s("[data-clear-pet-search]");
      t && !t.dataset.bound && (t.addEventListener("click", () => {
        var i;
        if (e) {
          const n = e.querySelector('[name="pawling_keyword"]'), c = e.querySelector('[name="pawling_location"]');
          n && (n.value = ""), c && (c.value = "");
          const state=e.querySelector('[name="pawling_state"]');
          if(state) state.value="";
          delete e.dataset.pawlingCityExact;
          window.PawlingMarketTools?.clear();
          window.PawlingGeography?.syncUrl("","","");
          ae("","All pets",false);
          window.PawlingGeography?.decorate();
        }
        window.__pawlingSavedResultsActive = false;
        const a = s("#pet-search-results");
        a && (a.hidden = true), (i = s("#current-listings, #pet-marketplace")) == null || i.scrollIntoView({ behavior: "smooth", block: "start" });
      }), t.dataset.bound = "true");
    }
    function j(e) {
      const t = h("[data-pawling-service]");
      let a = 0;
      t.forEach((n) => {
        const c = n.dataset.pawlingActive !== "false" && (!e || o(n.dataset.category) === o(e));
        n.hidden = !c, c && a++;
      });
      const i = s("#PawlingServiceEmpty");
      i && (i.hidden = a !== 0);
      const n = s("#PawlingServiceStatus");
      n && (n.textContent = e ? `Showing ${a} ${e} ${a === 1 ? "business" : "businesses"}.` : `Showing all ${a} local ${a === 1 ? "business" : "businesses"}.`), h("[data-service-filter]").forEach((p) => {
        const r = (p.dataset.serviceFilter || "") === (e || "");
        p.classList.toggle("is-active", r), p.setAttribute("aria-pressed", r ? "true" : "false");
      });
    }
    function ae(e, t, a) {
      const i = s("#current-listings"), n = i ? h("[data-pawling-live-listing]", i) : [];
      let c = 0;
      n.forEach((r) => {
        const d=F(r), keyword=s('[name="pawling_keyword"]')?.value || "";
        const l = x(r) && (!window.PawlingMarketTools || window.PawlingMarketTools.matches(d, true)) && N([d.title,d.type,d.category,d.location,d.advertiser,d.description,d.status].join(" "),keyword) && (!e || r.dataset.petCategory === e) && (!window.PawlingGeography || window.PawlingGeography.matches(r.dataset.searchLocation, window.PawlingGeography.formCity(), window.PawlingGeography.formState(), r.dataset.id, r.dataset.searchState, r.dataset.searchCity, window.PawlingGeography.formExactCity()));
        r.hidden = !l, l && c++;
      });
      window.PawlingMarketTools?.sortCards(n);
      const p = s("#PawlingCurrentCategoryStatus");
      p && (p.textContent = e ? `Showing ${c} ${t} ${c === 1 ? "ad" : "ads"}.` : `Showing ${c} current pet ${c === 1 ? "ad" : "ads"}.`);
      const r = s("#PawlingPetCategoryEmpty"), l = s("#PawlingPetCategoryEmptyTitle"), q = s("#PawlingPetCategoryPost");
      r && (r.hidden = c !== 0), l && (l.textContent = e ? `No ${t} ads match this location and search.` : "No current pet ads match this location and search."), q && (q.href = `/pages/seller-dashboard${e ? `?pet_type=${encodeURIComponent(e)}` : ""}#pawling-seller-upload`, q.textContent = e ? `Post ${t}` : "Post a pet");
      h("[data-pawling-pet-category]").forEach((B) => {
        const A = (B.dataset.pawlingPetCategory || "") === (e || "");
        B.classList.toggle("is-active", A);
        if (B.tagName === "BUTTON") B.setAttribute("aria-pressed", A ? "true" : "false");
        else if (A) B.setAttribute("aria-current", "true");
        else B.removeAttribute("aria-current");
      }), a && i && i.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    function rotateMarketplaceAds() {
      [[s("#current-listings .pawling-live-listing-grid"), "pawling_current_ad_rotation_v1"], [s("#paid-pet-spotlights .pawling-live-listing-grid"), "pawling_paid_ad_rotation_v1"]].forEach(([e, t]) => {
        if (!e || e.dataset.rotationApplied === "true") return;
        const a = Array.from(e.children).filter((c) => c.matches("[data-pawling-live-listing]") && c.dataset.pawlingActive !== "false");
        e.dataset.rotationApplied = "true";
        if (a.length < 2) return;
        let i = 0;
        try {
          const c = window.localStorage.getItem(t);
          if (c === null) {
            const p = new Uint32Array(1);
            i = window.crypto && window.crypto.getRandomValues ? (window.crypto.getRandomValues(p), p[0] % a.length) : Date.now() % a.length;
          } else i = (Number.parseInt(c, 10) + 1) % a.length;
          window.localStorage.setItem(t, String(i));
        } catch (c) {
          i = Date.now() % a.length;
        }
        const n = Array.from(e.children).find((c) => !c.matches("[data-pawling-live-listing]")) || null;
        [...a.slice(i), ...a.slice(0, i)].forEach((c) => e.insertBefore(c, n));
      });
    }
    function Q(e) {
      const t = document.getElementById(e);
      t && typeof t.showModal == "function" && t.showModal();
    }
    function H(e) {
      e != null && e.open && e.close();
    }
    function X(e, t, a) {
      var p;
      const i = s("#PawlingInquiryPuppy"), n = s("#PawlingInquiryPrice"), c = s("#PawlingInquirySeller");
      i && (i.value = e || ""), n && (n.value = t || ""), c && (c.value = a || ""), V("inquiry"), H(document.querySelector("dialog[open]")), (p = s("#post-a-puppy")) == null || p.scrollIntoView({ behavior: "smooth" }), setTimeout(() => {
        var r;
        return (r = s("#PawlingInquiryName")) == null ? void 0 : r.focus();
      }, 500);
    }
    function V(e) {
      h("[data-form-tab]").forEach((t) => {
        const a = t.dataset.formTab === e;
        t.classList.toggle("is-active", a), t.setAttribute("aria-selected", a ? "true" : "false");
      }), h("[data-form-panel]").forEach((t) => t.classList.toggle("is-active", t.dataset.formPanel === e));
    }
    function Z(e, t) {
      if (!e || !t) return;
      const a = Array.from(e.options).find((i) => o(i.value) === o(t) || o(i.textContent) === o(t));
      a && (e.value = a.value);
    }
    function z(e, t, a) {
      var r;
      V("business");
      const i = s("#PawlingBusinessRequestType");
      i && (i.value = "Claim an existing directory profile");
      const n = s("#PawlingBusinessName");
      n && (n.value = e || ""), Z(s("#PawlingBusinessCategory"), t || "");
      const c = s("#PawlingBusinessWebsite");
      c && a && (c.value = a);
      const p = s("#PawlingBusinessBody");
      p && !p.value && (p.value = "I am requesting ownership review for the Pawling directory profile listed above. Please contact me to verify my authority and confirm any updates."), (r = s("#post-a-puppy")) == null || r.scrollIntoView({ behavior: "smooth" }), setTimeout(() => {
        var l;
        return (l = s("#PawlingBusinessContact")) == null ? void 0 : l.focus();
      }, 500);
    }
    function ee() {
      let e;
      try {
        e = new URLSearchParams(window.location.search || "");
      } catch (r) {
        return;
      }
      window.PawlingMarketTools?.restore();
      const requestedState=e.get("state"), requestedCity=e.get("city")||"", requestedKeyword=e.get("q")||"";
      if (requestedState !== null || requestedCity || requestedKeyword) {
        const form=s("#PawlingHeroSearch"), state=window.PawlingGeography?.canonical(requestedState)||"";
        if (form) {
          form.elements.pawling_state.value=state;
          if(requestedState && !state) {
            const invalid=document.createElement('option');invalid.value='__invalid__';invalid.textContent='Choose a valid state';
            form.elements.pawling_state.append(invalid);form.elements.pawling_state.value='__invalid__';
          }
          form.elements.pawling_location.value=requestedCity;
          form.elements.pawling_keyword.value=requestedKeyword;
          form.dataset.pawlingCityExact=e.get("city_mode")==="exact" ? "true" : "false";
          $(requestedKeyword,requestedCity,false,{state:requestedState && !state ? 'Invalid state' : state,exactCity:form.dataset.pawlingCityExact==='true'});
          ae("","All pets",false);
        }
      }
      const t = e.get("form");
      (t === "seller" || t === "business" || t === "inquiry") && V(t);
      const a = e.get("claim_business");
      a && z(a, e.get("claim_category") || "", e.get("claim_website") || "");
      const i = e.get("inquiry");
      if (i) {
        const r = s("#PawlingInquiryPuppy");
        r && !r.value && (r.value = i + " listings");
      }
      const n = e.get("pet_type");
      if (n) {
        const r = s("#PawlingPetType"), l = { dogs: "Dog / Puppy", "cats-kittens": "Cat / Kitten", rabbits: "Rabbit", "small-animals": "Small Animal", birds: "Bird", reptiles: "Reptile", "fish-aquatics": "Fish / Aquatic", "farm-animals": "Farm Animal", "other-pets": "Other Pet" };
        r && l[n] && (r.value = l[n]);
      }
      if (e.get("saved") === "1") {
        const r = s("#PawlingSavedOnly");
        r && (r.checked = true, w()), $("", "", true, { savedOnly: true });
      }
      const c = e.get("seller");
      if (c) {
        const r = s("#PawlingKeyword");
        r && (r.value = c, w());
      }
      const p = e.get("browse");
      if (p) {
        const r = document.getElementById("sell-" + p), l = h("[data-pawling-pet-category]").find((q) => q.dataset.pawlingPetCategory === p), B = (l == null ? void 0 : l.dataset.categoryLabel) || p;
        r && (r.classList.add("is-route-target"), setTimeout(() => r.classList.remove("is-route-target"), 2400)), ae(p, B, false);
      }
    }
    function K() {
      const e = s("#PawlingMobileToggle"), t = s("#PawlingMobileNav");
      e && t && !e.dataset.bound && (e.addEventListener("click", () => {
        const a = t.classList.toggle("open");
        e.setAttribute("aria-expanded", a ? "true" : "false"), document.body.classList.toggle("pawling-menu-open", a);
      }), t.addEventListener("click", (a) => {
        a.target.closest("a") && (t.classList.remove("open"), e.setAttribute("aria-expanded", "false"), document.body.classList.remove("pawling-menu-open"));
      }), e.dataset.bound = "true"), h("[data-current-year]").forEach((a) => a.textContent = (/* @__PURE__ */ new Date()).getFullYear()), document.documentElement.dataset.pawlingClickBound || (document.addEventListener("click", (a) => {
        var U, D, Y, W;
        const i = a.target.closest("[data-pawling-favorite]");
        if (i) {
          a.preventDefault(), y(i.dataset.pawlingFavorite), u("save_listing", { listing_id: i.dataset.pawlingFavorite || "" });
          return;
        }
        const n = a.target.closest("[data-open-dialog]");
        if (n) {
          a.preventDefault();
          const C = n.dataset.openDialog || "", k = h("[data-pawling-market-card]").find((M) => M.dataset.searchDialog === C);
          u("view_listing", { listing_id: (k == null ? void 0 : k.dataset.id) || "", listing_title: (k == null ? void 0 : k.dataset.searchTitle) || (k == null ? void 0 : k.dataset.name) || "", listing_source: (k == null ? void 0 : k.dataset.searchSource) || "" }), Q(n.dataset.openDialog);
          return;
        }
        const c = a.target.closest("[data-close-dialog]");
        if (c) {
          a.preventDefault(), H(c.closest("dialog"));
          return;
        }
        const closeAndScroll = a.target.closest("[data-close-and-scroll]");
        if (closeAndScroll) {
          a.preventDefault(), H(closeAndScroll.closest("dialog"));
          const scrollTarget = document.getElementById(closeAndScroll.dataset.closeAndScroll || "");
          scrollTarget && scrollTarget.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
        const p = a.target.closest("[data-inquire-puppy]");
        if (p) {
          a.preventDefault(), u("start_inquiry", { listing_title: p.dataset.inquirePuppy || "" }), X(p.dataset.inquirePuppy, p.dataset.inquirePrice, p.dataset.inquireSeller);
          return;
        }
        const r = a.target.closest("[data-claim-business]");
        if (r) {
          a.preventDefault(), z(r.dataset.claimBusiness || "", r.dataset.claimCategory || "", r.dataset.claimWebsite || "");
          return;
        }
        const l = a.target.closest("[data-pawling-seller-filter]");
        if (l) {
          a.preventDefault();
          const C = s("#PawlingKeyword");
          C && (C.value = l.dataset.pawlingSellerFilter || ""), w(), (U = s("#puppies")) == null || U.scrollIntoView({ behavior: "smooth" });
          return;
        }
        const petCategoryControl = a.target.closest("[data-pawling-pet-category]");
        if (petCategoryControl) {
          a.preventDefault();
          const categoryKey = petCategoryControl.dataset.pawlingPetCategory || "", categoryLabel = petCategoryControl.dataset.categoryLabel || "Pets";
          window.PawlingMarketTools?.setCategory(categoryKey);
          ae(categoryKey, categoryLabel, true);
          window.PawlingMarketTools?.refreshResults();
          return;
        }
        const q = a.target.closest("[data-service-filter]");
        if (q) {
          a.preventDefault(), j(q.dataset.serviceFilter || ""), (D = s("#PawlingServiceGrid")) == null || D.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
        const B = a.target.closest("[data-form-tab]");
        if (B) {
          a.preventDefault(), V(B.dataset.formTab), B.closest(".pawling-form-tabs") || (Y = s("#post-a-puppy")) == null || Y.scrollIntoView({ behavior: "smooth" });
          return;
        }
        const A = a.target.closest("[data-faq-button]");
        if (A) {
          const k = A.closest(".faq-item").classList.toggle("open");
          A.setAttribute("aria-expanded", k ? "true" : "false");
          const M = A.querySelector("[data-faq-marker]");
          M && (M.textContent = k ? "\u2212" : "+");
          return;
        }
        const L = a.target.closest("[data-dialog-thumb]");
        if (L) {
          const C = L.closest(".pawling-dialog-gallery"), k = C == null ? void 0 : C.querySelector("[data-dialog-main-image]");
          k && (k.src = L.dataset.dialogThumb), h(".pawling-dialog-thumb", C).forEach((M) => M.classList.toggle("is-active", M === L));
        }
        const T = a.target.closest("[data-select-plan]");
        if (T) {
          const C = s("#PawlingSellerPlan");
          C && (C.value = T.dataset.selectPlan), V("seller"), (W = s("#post-a-puppy")) == null || W.scrollIntoView({ behavior: "smooth" });
        }
        const I = a.target.closest('a[href*="/pages/seller-dashboard"]');
        I && u("start_seller_listing", { destination: I.getAttribute("href") || "" });
        const O = a.target.closest('a[href*="#pawling-rehome-form"],a[href*="/pages/responsible-rehoming"]');
        O && u("start_rehoming_request", { destination: O.getAttribute("href") || "" });
        const d = a.target.closest('.pawling-live-listing-dialog a[href^="mailto:"],.pawling-live-listing-dialog a[href^="tel:"],.pawling-live-listing-dialog a[target="_blank"]');
        d && u("contact_advertiser", { method: (d.getAttribute("href") || "").split(":")[0] || "website" });
      }), document.documentElement.dataset.pawlingClickBound = "true"), h("dialog").forEach((a) => {
        a.dataset.bound || (a.addEventListener("click", (i) => {
          i.target === a && a.close();
        }), a.dataset.bound = "true");
      }), window.PawlingMarketTools?.restore(), f(), v(), rotateMarketplaceAds(), ie(), _(), J(), te(), j(""), ae("", "All pets", false), ee(), window.PawlingGeography?.bind(), window.PawlingMarketTools?.init();
    }
    document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", K) : K(), document.addEventListener("shopify:section:load", K), document.addEventListener("pawling:packages-ready", () => {
      f(), v(), rotateMarketplaceAds(), ie(), _(), w(), j(""), ae("", "All pets", false), window.PawlingGeography?.decorate(), window.__pawlingSavedResultsActive && $("", "", false, { savedOnly: true });
    });
    function te() {
      [["PawlingPuppyInquiry", "start_inquiry"], ["PawlingBusinessSubmission", "start_business_submission"], ["PawlingRehomeSubmission", "start_rehoming_request"], ["PawlingGiftCardSupport", "start_support_pledge"], ["PawlingNewsletter", "start_newsletter_signup"]].forEach(([a, i]) => {
        const n = document.getElementById(a);
        !n || n.dataset.conversionBound || (n.addEventListener("submit", () => u(i, {})), n.dataset.conversionBound = "true");
      }), [["PawlingPuppyInquiry", "submit_inquiry"], ["PawlingBusinessSubmission", "submit_business_submission"], ["PawlingRehomeSubmission", "submit_rehoming_request"], ["PawlingGiftCardSupport", "submit_support_pledge"], ["PawlingNewsletter", "submit_newsletter_signup"]].forEach(([a, i]) => {
        const n = document.getElementById(a);
        n != null && n.querySelector(".pawling-form-message.success") && !n.dataset.successTracked && (u(i, {}), n.dataset.successTracked = "true");
      });
    }
  })(), (function() {
    function s(f, v) {
      const y = document.createTreeWalker(f, NodeFilter.SHOW_TEXT), b = [];
      for (; y.nextNode(); ) b.push(y.currentNode);
      b.forEach((u) => {
        let o = u.nodeValue;
        v.forEach(([m, w]) => {
          o = o.replaceAll(m, w);
        }), u.nodeValue = o;
      });
    }
    async function h(f, v) {
      var y, b, u, o, m;
      try {
        const w = await fetch(`/products/${v}.js`, { credentials: "same-origin" });
        if (!w.ok) return;
        const _ = await w.json();
        let E = f;
        for (let F = 0; F < 5 && E && !((y = E.querySelector) != null && y.call(E, "h3")); F++) E = E.parentElement;
        if (!E) return;
        E.classList.add("pawling-plan-live-card");
        const N = [...E.querySelectorAll("p,strong,div,span")].filter((F) => F.children.length === 0 && /see product page/i.test(F.textContent.trim()));
        N[0] && (N[0].textContent = (((u = (b = window.Shopify) == null ? void 0 : b.currency) == null ? void 0 : u.active) || "USD") === "USD" ? `$${(_.price / 100).toFixed(_.price % 100 ? 2 : 0)}` : `${(_.price / 100).toFixed(2)} ${((m = (o = window.Shopify) == null ? void 0 : o.currency) == null ? void 0 : m.active) || ""}`);
        const R = E.querySelector("h3");
        R && /pro seller/i.test(R.textContent) && E.classList.add("is-most-popular"), R && /elite seller/i.test(R.textContent) && E.classList.add("is-elite");
      } catch (w) {
      }
    }
    function S(f) {
      if (!f) return false;
      const v = f.getBoundingClientRect();
      return v.width < 20 || v.height < 60 ? false : [...f.querySelectorAll('form,input:not([type="hidden"]),textarea,select,button,iframe')].some((y) => {
        const b = y.getBoundingClientRect(), u = window.getComputedStyle(y);
        return b.width > 10 && b.height > 4 && u.display !== "none" && u.visibility !== "hidden" && u.opacity !== "0";
      });
    }
    function g() {
      const f = document.querySelector("[data-pawling-seller-form-mount]"), v = document.querySelector(".pawling-free-upload-slot");
      if (!f || !v) return;
      let y;
      function b() {
        var u;
        S(f) && ((u = v.querySelector("[data-pawling-upload-help]")) == null || u.remove(), y && y.disconnect());
      }
      window.MutationObserver && (y = new MutationObserver(b), y.observe(f, { childList: true, subtree: true, attributes: true })), setTimeout(() => {
        var E;
        if (S(f) || v.querySelector("[data-pawling-upload-help]")) return;
        const u = (v.dataset.pawlingSellerFallbackUrl || "").trim(), o = window.location.origin + "/pages/seller-dashboard#pawling-seller-upload", m = u || o, w = document.createElement("div");
        w.className = "pawling-upload-browser-help", w.dataset.pawlingUploadHelp = "true", w.innerHTML = '<strong>The photo-upload form did not load in this browser.</strong><p>If you opened Pawling inside Facebook, Instagram or another app, use its \u2022\u2022\u2022 menu and choose <b>Open in browser</b>. Chrome, Safari and Edge work best.</p><div class="pawling-upload-browser-actions"><a class="button button-primary" data-seller-fallback-link target="_blank" rel="noopener">Open upload separately</a><button class="button button-light" type="button" data-copy-seller-link>Copy upload link</button><a class="button button-light" href="mailto:hello@pawlingpups.com?subject=Pawling%20photo-upload%20help">Email upload help</a></div><small>Your ad is not lost; reopen this page in a normal browser and submit it there.</small>', f.insertAdjacentElement("afterend", w);
        const _ = w.querySelector("[data-seller-fallback-link]");
        _ && (_.href = m, _.textContent = u ? "Open alternate upload form" : "Open upload in a new tab"), (E = w.querySelector("[data-copy-seller-link]")) == null || E.addEventListener("click", async (N) => {
          try {
            await navigator.clipboard.writeText(m), N.currentTarget.textContent = "Link copied";
          } catch (R) {
            window.prompt("Copy this Pawling upload link:", m);
          }
        });
      }, 5500);
    }
    function P() {
      let f;
      try {
        f = new URLSearchParams(window.location.search || "");
      } catch (b) {
        return;
      }
      if (f.get("listing_source") !== "rescue-shelter") return;
      const v = document.getElementById("pawling-seller-upload");
      if (!v || document.querySelector("[data-rescue-upload-note]")) return;
      const y = document.createElement("div");
      y.className = "pawling-warning", y.dataset.rescueUploadNote = "true", y.innerHTML = "<strong>Rescue or shelter listing:</strong> choose the Rescue / Shelter source when the form offers it. Include the organization name, official website or application, adoption fee, included veterinary care and direct placement policies. Pawling can apply the separate source label during listing setup; your organization keeps its own screening and contract.", v.insertAdjacentElement("beforebegin", y);
    }
    function T() {
      let f;
      try {
        f = new URLSearchParams(window.location.search || "");
      } catch (w) {
        return;
      }
      const v = f.get("pet_type"), y = {
        dogs: ["Dogs", "Dog / Puppy"],
        "cats-kittens": ["Cats & Kittens", "Cat / Kitten"],
        rabbits: ["Rabbits", "Rabbit"],
        "small-animals": ["Small Animals", "Small Animal"],
        birds: ["Birds", "Bird"],
        reptiles: ["Reptiles", "Reptile"],
        "fish-aquatics": ["Fish & Aquatics", "Fish / Aquatic"],
        "farm-animals": ["Farm Animals", "Farm Animal"],
        "other-pets": ["Other Pets", "Other Pet"]
      }[v], b = document.querySelector("[data-pawling-seller-form-mount]");
      if (!y || !b) return;
      let u = document.querySelector("[data-pawling-category-upload-note]");
      if (!u) {
        u = document.createElement("div"), u.className = "pawling-category-upload-note", u.dataset.pawlingCategoryUploadNote = "true";
        const w = document.createElement("strong"), _ = document.createElement("span");
        w.textContent = `Posting ${y[0]}.`, _.textContent = `Choose ${y[1]} in the upload form. Pawling will select it automatically when the form exposes that field; please confirm before posting.`, u.append(w, _), b.insertAdjacentElement("beforebegin", u);
      }
      const o = (w) => String(w || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim(), m = o(y[1]), E = o(v), N = () => {
        let w = false;
        b.querySelectorAll("select").forEach((_) => {
          const R = o([_.name, _.id, _.getAttribute("aria-label"), _.parentElement && _.parentElement.textContent].join(" "));
          if (!/(category|pet type|animal type)/.test(R)) return;
          const F = Array.from(_.options).find((G) => {
            const J = o(`${G.value} ${G.textContent}`);
            return J.includes(m) || J.includes(E) || m.includes(J) && J.length > 2;
          });
          F && _.value !== F.value && (_.value = F.value, _.dispatchEvent(new Event("input", { bubbles: true })), _.dispatchEvent(new Event("change", { bubbles: true })), w = true);
        }), b.querySelectorAll('input[type="radio"]').forEach((_) => {
          const R = _.closest("label"), F = o(`${_.value} ${R ? R.textContent : ""}`);
          (F.includes(m) || F.includes(E)) && !_.checked && (_.checked = true, _.dispatchEvent(new Event("input", { bubbles: true })), _.dispatchEvent(new Event("change", { bubbles: true })), w = true);
        });
        if (w) {
          const _ = u.querySelector("span");
          _ && (_.textContent = `${y[1]} was selected in the upload form. Please confirm it before posting.`);
        }
        return w;
      };
      if (N() || !window.MutationObserver) return;
      const A = new MutationObserver(() => {
        N() && A.disconnect();
      });
      A.observe(b, { childList: true, subtree: true }), setTimeout(() => A.disconnect(), 12e3);
    }
    function x() {
      var u;
      if (!document.body.classList.contains("path-pages-seller-dashboard")) return;
      g(), P(), T();
      const f = document.querySelector(".seller-dashboard-page .pawling-rte");
      if (!f) return;
      s(f, [["List Your Puppies on Pawling", "List Your Pets on Pawling"], ["Reach thousands of Arizona families looking for their perfect puppy.", "Reach pet families near you and across the U.S."], ["Post a puppy listing for free", "Post a pet listing for free"], ["puppy listing", "pet listing"], ["Puppy listing", "Pet listing"], ["puppy listings", "pet listings"], ["Puppy listings", "Pet listings"]]), [...f.querySelectorAll("a")].forEach((o) => {
        var w;
        let m = o;
        for (let _ = 0; _ < 5 && m && !((w = m.querySelector) != null && w.call(m, "h3")); _++) m = m.parentElement;
        m && m.classList.add("pawling-plan-live-card");
      }), ["featured-boost-7-days", "pro-seller-30-days", "elite-seller-30-days", "local-business-featured-30-days"].forEach((o) => {
        const m = f.querySelector(`a[href*="/products/${o}"]`);
        m && h(m, o);
      });
      const b = [...f.querySelectorAll("a,button")].find((o) => /submit free ad/i.test(o.textContent));
      if (b) {
        let o = b;
        for (let m = 0; m < 5 && o && !((u = o.querySelector) != null && u.call(o, "h3")); m++) o = o.parentElement;
        o && o.classList.add("pawling-plan-live-card", "is-free");
      }
    }
    document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", x) : x();
  })(), (function() {
    "use strict";
    function s(g) {
      if (!g || g.charAt(0) !== "#") return null;
      try {
        var P = document.querySelector(g);
        return P && P.matches("details.pawling-collapsible-form") ? P : null;
      } catch (x) {
        return null;
      }
    }
    function h(g) {
      var P = s(window.location.hash);
      P && (P.open = true, g && setTimeout(function() {
        P.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 20));
    }
    function S() {
      document.querySelectorAll("details.pawling-collapsible-form").forEach(function(g) {
        g.querySelector(".pawling-form-message") && (g.open = true);
      }), h(false);
    }
    document.addEventListener("click", function(g) {
      var P = g.target.closest('a[href^="#"]');
      if (P) {
        var x = s(P.getAttribute("href"));
        x && (x.open = true);
      }
    }), window.addEventListener("hashchange", function() {
      h(true);
    }), document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", S) : S(), document.addEventListener("shopify:section:load", S);
  })(), (function() {
    "use strict";
    function s() {
      if (window.location.hash === "#pet-brief-archive") {
        var S = document.getElementById("pet-brief-archive");
        S && (S.open = true);
      }
    }
    function h() {
      document.querySelectorAll("[data-pawling-brief-archive]").forEach(function(S) {
        var g = S.querySelector("[data-pawling-brief-archive-search]");
        if (!g || g.dataset.bound === "true") return;
        var P = Array.prototype.slice.call(S.querySelectorAll("[data-pawling-brief-archive-item]")), x = S.querySelector("[data-pawling-brief-archive-status]"), f = S.querySelector("[data-pawling-brief-archive-none]");
        function v() {
          var y = g.value.trim().toLowerCase(), b = 0;
          P.forEach(function(u) {
            var o = !y || (u.textContent || "").toLowerCase().indexOf(y) !== -1;
            u.hidden = !o, o && (b += 1);
          }), x && (x.textContent = b + " past " + (b === 1 ? "item" : "items")), f && (f.hidden = b !== 0);
        }
        g.addEventListener("input", v), g.dataset.bound = "true", v();
      }), s();
    }
    document.addEventListener("click", function(S) {
      var g = S.target.closest('a[href="#pet-brief-archive"]');
      if (g) {
        var P = document.getElementById("pet-brief-archive");
        P && (P.open = true);
      }
    }), window.addEventListener("hashchange", s), document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", h) : h(), document.addEventListener("shopify:section:load", h);
  })();
})();
